import { SafeString } from 'handlebars/dist/handlebars';

export function cFeatures(options) {
  let { count } = options.hash;
  count = count ? ' c-features--' + count : '';
  return new SafeString(`<div class="c-features${count}" title="">${options.fn(this)}</div>`);
}
